export default __webpack_public_path__ + "static/media/c1.320530b4.jpeg";